<div #component class="component">
	<div class="requestedSkillsDiv">
		<span class="requestedSkillsTitle">{{ _lang("requested-skills") }}</span>
		<div class="requestedSkillsContentRow">
			<div #canvasContainer class="canvasContainer">
				<app-highcharts-chart class="requestedSkillsChart" [options]="requestedSkillsChartOptions">
				</app-highcharts-chart>
			</div>
			<ul #requestedSkillsList></ul>
		</div>
	</div>
	<div class="matchingProfilesDiv">
		<span class="matchingProfilesTitle">
			{{ _lang("matching-profiles") }}: {{ position.matchingEmployees.length }}
		</span>

		<button class="close-button" (click)="resetProfileButtonRow()" [class.visible]="expandedButtonIndex > -1">
			<mat-icon>close</mat-icon>
		</button>
		<div class="employeeProfileButtonRow" #employeeProfileButtonRow>
			@for (matchingEmployee of position.matchingEmployees; track matchingEmployee; let i = $index) {
				<button
					#employeeProfileButton
					[class.expanded]="i === expandedButtonIndex"
					(click)="handleProfileButtonClick(i)"
					class="employeeProfilesButton"
				>
					<app-employee-profile
						[matchingEmployee]="matchingEmployee"
						[returnSkillLevelFromArray]="returnSkillLevelFromArray"
						[requestedSkills]="position.requestedSkills"
						#employeeProfile
						class="employeeProfile"
					>
					</app-employee-profile>
				</button>
			}
		</div>
	</div>
</div>
